let mapInstance: mapboxgl.Map | null = null;

export const setMapInstance = (map: mapboxgl.Map) => {
  mapInstance = map;
};

export const getMapInstance = (): mapboxgl.Map | null => mapInstance;
